module.exports = __webpack_public_path__ + "img/volk-pivo.ad5be056.svg";